import { render, staticRenderFns } from "./pendencias.vue?vue&type=template&id=07064a72"
import script from "./pendencias.vue?vue&type=script&lang=js"
export * from "./pendencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports